export const ACCOUNT_TYPE = {
    USER: "rm",
    ADMIN: 'admin',
    RM:"mainRm",
    MANAGER:"manager",
    TEAMSUSER:"teamsUser"
  }